import { SpiderRepository } from '@/core/api/spiders'

const spiders = new SpiderRepository()

export default {
  namespaced: true,
  state: {
    items: [],
    itemsCount: 0,
    page: 1,
    pageSize: 20,
    pageCount: 1,
    loading: false,
    filter: {},
    lastClickedIndex: -1,
    secondaryOrderingColumn: '-modified',
  },
  actions: {
    async FETCH({ state, commit }) {
      commit('FETCH_REQUEST')

      return spiders
        .getPage(state.page, {
          ['page_size']: state.pageSize,
          ...state.filter,
        })
        .then(({ data }) => {
          commit('SET_STATE', data)
          commit('SET_PAGINATION', { page: state.page, pages: data.pages })
        })
        .catch(err => {
          return Promise.reject(err)
        })
        .finally(() => {
          commit('END_REQUEST')
        })
    },
    /* eslint-disable @typescript-eslint/camelcase */
    CREATE(
      context,
      { source, status, settings, note, cooldown, plugin_id, additional, enable_cleaner },
    ) {
      return spiders.create({
        source: source.id,
        status,
        settings,
        note,
        cooldown,
        plugin_id,
        additional,
        enable_cleaner,
      })
    },
    UPDATE(
      context,
      {
        id,
        source,
        status,
        settings,
        note,
        cooldown,
        plugin_id,
        additional,
        enable_cleaner,
        developer,
        override_publish_date,
        proxy_list,
        use_browser_service,
      },
    ) {
      return spiders.update(id, {
        source: source.id,
        status,
        settings,
        note,
        cooldown,
        plugin_id,
        additional,
        enable_cleaner,
        developer,
        override_publish_date,
        proxy_list: proxy_list ?? null,
        use_browser_service,
      })
    },
    BULK_UPDATE(context, { ids, status, plugin, cooldown, clustered }) {
      return spiders.bulkUpdate(ids, { status, cooldown, clustered, plugin_id: plugin })
    },
    BULK_DELETE(context, { ids }) {
      return spiders.bulkDelete(ids)
    },
    BULK_ANALYZE(context, { ids }) {
      return spiders.bulkAnalyze(ids)
    },
    DELETE(context, { id }) {
      return spiders.delete(id)
    },
  },
  mutations: {
    FETCH_REQUEST: state => {
      state.loading = true
    },
    END_REQUEST: state => {
      state.loading = false
    },
    SET_STATE: (state, { results, count }) => {
      state.items = results
      state.itemsCount = count
    },
    SET_PAGINATION: (state, { page, pages }) => {
      state.page = page
      state.pageCount = pages
    },
    SET_FILTER: (state, filter) => {
      state.filter = { ...state.filter, ...filter }
    },
    SET_ORDERING: (state, column) => {
      const param = column ? `${column},${state.secondaryOrderingColumn}` : ''
      state.filter = { ...state.filter, ordering: param }
    },
    SET_PAGE: (state, page) => {
      state.page = page
    },
    SET_PAGE_SIZE: (state, pageSize) => {
      state.pageSize = pageSize
    },
    SET_LAST_CLICKED_ROW: (state, spiderId) => {
      state.lastClickedIndex = state.items.map(x => x.id).indexOf(spiderId)
    },
    CLEAR_LAST_CLICKED_ROW: state => {
      state.lastClickedIndex = -1
    },
  },
  getters: {
    lastClickedRow(state) {
      const idx = Math.min(state.lastClickedIndex, state.items.length - 1)
      return state.items[idx] && state.items[idx].id
    },
  },
}
